import React from "react"
import * as Sentry from "@sentry/react"
import { ApolloProvider } from "@apollo/client"
import { BrowserRouter as Router, useLocation } from "react-router-dom"
import HeaderEnhanced from "./components/Header/HeaderEnhanced"
import { ErrorBoundary } from "@swipesense/error-handling"
import { Switch, Route } from "react-router-dom"
import { NotFound } from "@swipesense/error-handling"
import routes from "./routes"
import Cases from "./routes/Cases"
import LandingPageWithData from "./components/LandingPage/LandingPageWithData"
import CaseDetailEnhanced from "./routes/CaseDetail/CaseDetailEnhanced"
import OverviewWithData from "./routes/Overview/OverviewWithData"
import "./App.scss"
import apolloClient from "./apollo/apolloClient"

/* istanbul ignore next */
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    environment: process.env.REACT_APP_STAGE,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  })
}

const FunctionalApp = () => {
  return (
    <div className="App page">
      <HeaderEnhanced homeLink="/" />
      <div className="content">
        <ErrorBoundary
          location={useLocation().pathname}
          onError={
            /* istanbul ignore next */ (error, _) =>
              Sentry.captureException(error)
          }
        >
          <Switch>
            <Route exact path={routes.home}>
              <LandingPageWithData />
            </Route>
            <Route exact path={routes.overview}>
              <OverviewWithData />
            </Route>
            <Route exact path={routes.openCases}>
              <Cases />
            </Route>
            <Route exact path={routes.archivedCases}>
              <Cases />
            </Route>
            <Route exact path={routes.caseDetail}>
              <CaseDetailEnhanced />
            </Route>
            <Route component={NotFound} />
          </Switch>
        </ErrorBoundary>
      </div>
      <footer />
    </div>
  )
}

const App = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <Router>
        <FunctionalApp />
      </Router>
    </ApolloProvider>
  )
}

export default App
export { FunctionalApp }
